import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { MESSAGE, ROUTE, CONTENT_TYPE } from '../config'
import { getPublicationsForVehicle, sortContentsByTitle } from '../extras/utils'
import { trackVideosFolderClick } from 'tw-oi-core/services/analytics'

import { connect } from 'react-redux'
import BrowseGuideLayout from '../components/BrowseGuideLayout'
import ContentList from '../components/ContentList'
import Icon from '../components/Icon'

import '../styles/Topics.scss'
import { filteredContents } from './BrandSpecificInformation/BrandSpecificInformation'

const Videos = ({ items, match, baseRoute }) => {
  const [videos, folders] = useMemo(() => {
    if (match.params.pseudoFolderName) {
      const videosWithinTag = sortContentsByTitle(
        items
          .filter(video => video.tags && video.tags.includes(match.params.pseudoFolderName))
          .map(video => ({
            ...video,
            link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.VIDEOS}/${match.params.pseudoFolderName}${ROUTE.CONTENT}/${video.resourceKey}`,
            icon: <Icon type='video' />,
          }))
      )
      return [videosWithinTag, []]
    }

    const videosWitoutTags = [...items]
      .filter(vid => !vid.tags || !vid.tags.length)
      .map(vid => ({
        ...vid,
        link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.VIDEOS}${ROUTE.CONTENT}/${vid.resourceKey}`,
        icon: <Icon type='video' />,
      }))
      .sort((a, b) => a.title.localeCompare(b.title))

    const folderItems = [...new Set(items.reduce((tags, vid) => tags.concat(vid.tags || []), []))].sort().map(tagTitle => ({
      title: tagTitle,
      type: CONTENT_TYPE.FOLDER,
      resourceKey: tagTitle,
      link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.VIDEOS}/${tagTitle}`,
      icon: <Icon type='folder' />,
    }))

    return [videosWitoutTags, folderItems]
  }, [items, match, baseRoute])

  return (
    <BrowseGuideLayout match={match} baseRoute={baseRoute}>
      {folders.length ? (
        <ContentList
          variant='browse-guide'
          topics={folders}
          emptyText={MESSAGE.EMPTY_TOPICS}
          baseRoute={match.url}
          onClick={item => trackVideosFolderClick(item.title)}
        />
      ) : null}

      {videos.length ? (
        <ContentList
          variant='browse-guide'
          topics={videos}
          emptyText={MESSAGE.EMPTY_TOPICS}
          baseRoute={match.url}
        />
      ) : null}
    </BrowseGuideLayout>
  )
}

Videos.propTypes = {
  items: PropTypes.array,
  match: PropTypes.object.isRequired,
  baseRoute: PropTypes.string,
}

function mapStateToProps({ contents }) {
  const processedContents = filteredContents(contents)
  const contentVideos = getPublicationsForVehicle(processedContents.videos)
  const items = sortContentsByTitle(contentVideos)

  return { items }
}

export default connect(mapStateToProps)(Videos)
